import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

// ============================================================================
// PAYLOAD MAPPING
// ============================================================================

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.length,
    W: input.tributaryWidth,
    Lo: input.hingeDistance,
    weight: input.weight,
    orientation: input.orientation,
    KLM: input.klm,
    xsi: input.damping,
    d0: input.u0,
    v0: input.v0,

    // CSV strings
    Rn: input.resistanceNL,
    Xn: input.deflectionNL,
    Re: input.resistanceLinear,
    Xe: input.deflectionLinear,
    Pa: input.pressureHistory,
    td: input.timeHistory
  };
}

const { analyze: analyzeRequest, analyzeCancellable: analyzeRequestCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>('/iSDOFSolver/', mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyzeRequest, analyzeRequestCancellable };
